<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>tag</md-icon>
          </div>
          <h4 class="title">Add Status Option</h4>
        </md-card-header>

        <form @submit.prevent="add">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Name
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="statusOption.name" />
                  <validation-error :errors="apiValidationErrors.name" />
                </md-field>
              </div>
            </div>
            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Order
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="statusOption.order" />
                  <validation-error :errors="apiValidationErrors.order" />
                </md-field>
              </div>
            </div>
            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Action Name
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="statusOption.action" />
                  <validation-error :errors="apiValidationErrors.action" />
                </md-field>
              </div>
            </div>
            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Is Active?
              </label>
              <div class="md-layout-item">
                <md-field>
                  <label>Select ...</label>
                  <md-select v-model="statusOption.is_active" name="is_active">
                    <md-option value=1>Yes</md-option>
                    <md-option value=0>No</md-option>
                  </md-select>
                </md-field>
                <validation-error :errors="apiValidationErrors.is_active" />
              </div>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Model
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="statusOption.model" />
                  <validation-error :errors="apiValidationErrors.model" />
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Color
              </label>
              <div class="md-layout-item md-alignment-center">
                <md-field class="md-invalid">
                  <color-picker v-model="color" style="width: 100%" />
                  <validation-error :errors="apiValidationErrors.color" />
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Add Status Option</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Slider } from 'vue-color';
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: {
        'color-picker': Slider,
        'validation-error': ValidationError,
    },

    mixins: [formMixin],

    data: () => ({
        statusOption: {
            type: 'statusOptions',
            name: null,
            order: null,
            action: null,
            is_active: null,
            model: null,
            color: null,
        },
        color: {
            hex: '#A1FF00',
        },
    }),

    watch: {
        color: {
            handler: 'updateStatusColor',
            immediate: true,
            deep: true,
        },
    },

    methods: {
        async add () {
            try {
                await this.$store.dispatch('statusOptions/add', this.statusOption);
                this.notifySuccess('Status Option added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },

        updateStatusColor () {
            this.statusOption.color = this.color.hex;
        },

        goBack () {
            this.$router.push({ name: 'List Status Options' });
        },
    },
};
</script>

<style lang="scss">
.spacing {
  padding-bottom: 1rem;
}
</style>
